import {LogoBrand} from './LogoBrand.tsx';
import {ChipTone, type BankCardSkin} from './types.ts';

function Face() {
    return (
        <>
            <div className="absolute inset-0 bg-[#EFEFF0]" />
            <svg aria-hidden className="absolute inset-0 h-full w-full" viewBox="0 0 400 252" preserveAspectRatio="none">
                <path d="M -20 300 A 340 340 0 0 1 430 -60" fill="none" stroke="#1F6BD6" strokeWidth="2.4" strokeOpacity="0.7" />
                <path d="M 120 300 A 260 260 0 0 1 470 90" fill="none" stroke="#1F6BD6" strokeWidth="2.4" strokeOpacity="0.38" />
            </svg>
        </>
    );
}

export const rabobankSkin: BankCardSkin = {
    Face,
    Brand: LogoBrand,
    chipTone: ChipTone.Silver,
    hasMastercard: true,
    surfaceTone: 'light',
    contentColor: '#23252B',
    labelColor: '#5F636C',
    contactlessColor: '#8B8E96',
    mastercardWordColor: '#5F636C',
};
